import { render, staticRenderFns } from "./EntradaForm.vue?vue&type=template&id=1ebd8a57&"
import script from "./EntradaForm.vue?vue&type=script&lang=js&"
export * from "./EntradaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports